import React, { useEffect } from "react";
import { Outlet, useNavigate, useParams } from "react-router-dom";

import { useMeQuery } from "../queries/me.queries";
import CompanyNavBar from "../company-navbar";
import { setCompanyToLocalStorage } from "../helper";

export function CompanyProtectedRoute() {
  const navigate = useNavigate();
  const { companyId } = useParams();
  const { data: currentUser, isFetched } = useMeQuery();

  useEffect(() => {
    if (isFetched && !currentUser?.acceptedPrivacy) {
      navigate("/accept-privacy");
    }
    setCompanyToLocalStorage(companyId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isFetched, currentUser]);

  if (!isFetched) return null;

  return (
    <div>
      <CompanyNavBar />
      <Outlet />
    </div>
  );
}
